import { Building2, Shield } from "lucide-react";
import { Link } from "react-router-dom";
import RegisterBenefits from "../components/auth/RegisterBenefits"; // Relative path
import RegisterForm from "../components/auth/RegisterForm"; // Relative path
import SocialRegister from "../components/auth/SocialRegister"; // Relative path
import { useAuth } from "../context/AuthContext"; // Relative path

const Register = () => {
  const { isLoading } = useAuth();

  return (
    <div className="bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2">
          <Building2 className="h-10 w-10 text-propertylk-blue" />
          <span className="font-bold text-2xl text-propertylk-darkblue">
            PropertyLK
          </span>
        </Link>
        <h2 className="mt-6 text-center text-3xl font-bold text-gray-900">
          Create a new account
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          Or{" "}
          <Link
            to="/login"
            className="font-medium text-propertylk-blue hover:text-propertylk-darkblue"
          >
            sign in to your existing account
          </Link>
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <RegisterBenefits />
          <RegisterForm />
          <SocialRegister isLoading={isLoading} />

          <div className="mt-6 pt-4 border-t border-gray-200">
            <div className="flex items-center">
              <Shield className="h-5 w-5 text-gray-400 mr-2" />
              <span className="text-xs text-gray-500">
                Your data is secured following our privacy policy
              </span>
            </div>
          </div>
        </div>

        <div className="mt-6 text-center">
          <p className="text-sm text-gray-600">
            Are you a property owner or agency?
          </p>
          <Link
            to="/register?type=agent"
            className="mt-2 inline-block text-sm font-medium text-propertylk-blue hover:text-propertylk-darkblue"
          >
            Register as a property owner or agency →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Register;
